import { ButtonERP } from "@finanedi.es/storybook"
import { faAdd } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DireccionReadingDtoProps } from "api/DTOs/DireccionReadingDto"
import MapDisplay from "common/components/MapDisplay"
import Modal from "common/components/Modal/Modal"
import DireccionService from "common/services/DireccionService"
import { contactoUpdateSuccessAlert } from "features/Contactos/constants"
import { getDefaultCountry } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { useSelector } from "hooks/useSelector"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import DireccionSocialForm from "../../forms/DireccionSocial"

const DireccionSocial = ({
  empresaContactoId,
  direccion,
  contactoByIdRefetch,
}: {
  empresaContactoId?: string
  direccion?: DireccionReadingDtoProps | null
  contactoByIdRefetch: () => void
}) => {
  const { t } = useTranslation()
  const [showEditDirectionModal, seShowEditDirectionModal] = useState(false)
  const businessDefaultCountry = useSelector(getDefaultCountry)

  const address = `${direccion?.calle} - ${direccion?.codigoPostal}`

  const handleUpdateSuccess = () => {
    contactoByIdRefetch()
    seShowEditDirectionModal(false)
    contactoUpdateSuccessAlert(t)
  }

  const updateDireccionSocial = (payload: $TSMigrationFixMe) => {
    const call =
      DireccionService[direccion ? "updateDireccion" : "insertDireccion"]

    call(payload).then(handleUpdateSuccess)
  }

  return (
    <div className='tw-flex tw-flex-col tw-items-start tw-pt-6'>
      <div className='tw-mb-2 tw-text-sm tw-font-medium'>
        {t("contactos.editar.labelFiscalDirection")}
      </div>
      {direccion ? (
        <div className='tw-px-4 tw-py-2 tw-bg-simple-10 tw-shadow-card tw-flex tw-flex-col tw-items-start tw-w-full tw-gap-0.5'>
          <MapDisplay
            postalCode={direccion.codigoPostal ?? ""}
            address={address}
          />
          <div className='tw-text-sm tw-font-medium tw-text-start tw-mt-1'>
            {direccion?.poblacionNombre ?? ""}
          </div>
          <div className='tw-text-sm tw-font-normal tw-text-start tw-text-text-50'>
            {address ?? ""}
          </div>
          <p
            className='!tw-text-text-hyperlinks !tw-text-sm hover:!tw-underline'
            onClick={() => seShowEditDirectionModal(true)}
          >
            {t("contactos.editar.labelEditFiscalDir")}
          </p>
        </div>
      ) : (
        <div className='tw-w-full tw-h-fit tw-border tw-border-dashed tw-rounded-md '>
          <ButtonERP
            customize={{
              size: "md",
              type: "none",
            }}
            icon={<FontAwesomeIcon icon={faAdd} />}
            label={`${t("contactos.editar.addNewFiscalDir")}`}
            onClick={() => seShowEditDirectionModal(true)}
            className='!tw-w-full'
          />
        </div>
      )}
      <Modal
        header={`${t("contactos.editar.modal.headerFisDir")}`}
        visible={showEditDirectionModal}
        closable={false}
        size='small'
      >
        <DireccionSocialForm
          // @ts-expect-error TS(2322): Type '{ data: null; empresaId: $TSFixMe; updateData: (p...
          data={direccion}
          empresaId={empresaContactoId}
          updateData={updateDireccionSocial}
          onHide={() => seShowEditDirectionModal(false)}
          countrySelected={businessDefaultCountry}
          t={t}
        />
      </Modal>
    </div>
  )
}

export default DireccionSocial
